import React, { useState } from 'react'
import PopupAnimation from '../../../components/animations/PopupAnimation'
import { FiSearch } from "react-icons/fi";
import Checkbox from '../../../components/Input/Checkbox';
import { db } from '../../../config/firebase';
import { v4 as uuidv4 } from 'uuid';
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
  onSnapshot
} from "firebase/firestore";
import dayjs from 'dayjs';

function ForwardPopUp({ isForwardWindowOpenData, groups, message }) {

  const [innerSearch, setInnerSearch] = useState("")
  const [frToGroups, setFrToGroups] = useState(groups.map((item) => ({ ...item, selected: false })))
  const [isForwardWindowOpen, setIsForwardWindowOpen] = isForwardWindowOpenData;


  const handleGroupSelection = (groupId) => {
    // console.log(groupId);
    setFrToGroups((prev) => prev.map((item) => {
      if (item.groupId === groupId) return {
        ...item, selected: !item.selected
      }
      return item
    }
    ))
  }

  const handleForwardMessage = (message) => {
    const enteredData = {
      ...message,
      createdAt: dayjs().format(),
      isForwarded: true,
      createdById: localStorage.getItem("uid"),
      displayName: localStorage.getItem("displayName"),
    }
    for (const grp of frToGroups.filter((item) => item.selected)) {
      // console.log(frToGroups.filter((item) => item.selected));
      sendChatToFireStore(enteredData, uuidv4(), grp.groupId)
    }

    setIsForwardWindowOpen(false)
    console.log("Forwarded Successfully");
  }

  const sendChatToFireStore = async (payload, id, groupId) => {

    try {
      const docRef = doc(db, 'chats', id);
      await setDoc(docRef, { ...payload, groupId });

    } catch (error) {
      console.log(error);
    }
  }


  return (

    <PopupAnimation showDiv={isForwardWindowOpen} >
      <div className="relative flex w-[90vw] h-[75vh] md:w-[382px] p-4 pt-4 md:p-5 flex-col justify-start rounded-xl bg-white shadow-lg outline-none dark:bg-navy-800 focus:outline-none">

        <button
          onClick={() => {
            setIsForwardWindowOpen(false)
          }}
          type="button"
          className="bg-transparent absolute absolute top-0 right-0 h-fit w-fit p-2 items-center justify-center rounded-xl text-sm text-gray-400 ms-auto hover:bg-gray-200 hover:text-neuGray dark:hover:bg-gray-600 dark:hover:text-white"
          data-modal-hide="static-modal"
        >
          <svg
            className="h-3 w-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close modal</span>
        </button>

        <div className="text-2xl font-semibold text-center text-headPrimary"> Forward To </div>
        <div className='w-full h-[calc(100%-123px)] p-3 mt-6 flex flex-col bg-lightPrimary rounded-lg' >

          <div className=" h-fit w-[150px] ">
            <div className="border border-gray-300 bg-white text-gray-700 z-1 flex h-[30px] md:h-[28px] w-full flex-grow items-left justify-start gap-2 rounded-md px-1.5 py-0.5">
              <div className="flex h-full w-full items-center font-normal ">
                <FiSearch
                  className="h-3 w-3 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                <input
                  onChange={(e) => {
                    setInnerSearch((e.target.value))
                  }}
                  value={innerSearch}
                  type="text"
                  placeholder="Search for Groups"
                  className="block ml-0 px-2 h-auto w-full bg-white text-sm text-gray-700 outline-none placeholder:!text-gray-400"
                />
              </div>

            </div>
          </div>

          <div className="w-full max-h-[calc(100%-42px)] overflow-y-auto mt-4 py-0 grid grid-cols-1 border rounded">

            {frToGroups
              .filter((item) => (item.name.toLowerCase().includes(innerSearch.toLowerCase())))
              .map((item, ind) => (
                <label htmlFor={item.groupId + "BTN--"}
                  // onClick={() => (handleGroupSelection(item.name))}
                  key={item.groupId + "BTN123"} className={`flex w-full items-center ${item.selected ? "font-semibold" : ""} hover:font-bold ${ind % 2 ? "bg-gray-50" : "bg-white"} py-1 px-2 cursor-pointer group`}>

                  <Checkbox
                    checked={item.selected}
                    onChange={() => (handleGroupSelection(item.groupId))}
                    id={item.groupId + "BTN--"} />

                  <div className="ms-2 flex flex-col text-left font-normal capitalize text-base hover:text-gray-800 dark:text-gray-300 group-hover:font-bold">
                    <div className="">{item.name}</div>
                    <div className="text-gray-600 text-xs">{item.groupId}</div>
                  </div>
                </label >

              ))}
          </div>
        </div>

        <div className="w-full flex items-center justify-center">

          <button
            onClick={() => { handleForwardMessage(message) }}
            className=" mt-5 flex items-center justify-center py-2 w-[200px] bg-white rounded-md border text-xl text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold">
            Forward
          </button>


        </div>
      </div>
    </PopupAnimation>
  )
}

export default ForwardPopUp